"use strict";

require("core-js/modules/es6.function.name");

require("core-js/modules/es6.array.sort");

require("core-js/modules/es7.array.includes");

require("core-js/modules/es6.string.includes");

require("core-js/modules/es6.array.filter");

require("core-js/modules/es6.array.map");

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var tslib_1 = require("tslib");

var helpers_1 = require("./helpers");

var N3 = require('n3');

var DataFactory = N3.DataFactory;
var namedNode = DataFactory.namedNode;

function isClass(uri, model, prefixes) {
  var quad = model.getQuads(namedNode(uri), namedNode(prefixes.rdf + "type"), namedNode(prefixes.owl + "Class"), null)[0];
  return !!quad;
}

exports.isClass = isClass;

function getClasses(model, prefixes) {
  var quads = model.getQuads(null, namedNode(prefixes.rdf + "type"), namedNode(prefixes.owl + "Class"), null);
  var classes = quads.filter(function (quad) {
    return !quad.subject.id.includes('_:');
  }).map(function (quad) {
    return getClass(quad.subject.id, model, prefixes);
  });
  return classes.sort(function (c1, c2) {
    return c1.name > c2.name ? 1 : -1;
  });
}

exports.getClasses = getClasses;

function getClass(uri, model, prefixes) {
  return tslib_1.__assign(tslib_1.__assign({}, helpers_1.getElement(uri, model, prefixes)), {
    disjointWith: [],
    isDomainOf: getDomainRelations(uri, model, prefixes),
    isRangeOf: getRangeRelations(uri, model, prefixes),
    supertypes: getSupertypes(uri, model, prefixes),
    subtypes: getSubtypes(uri, model, prefixes),
    stereotypes: getStereotype(uri, model, prefixes)
  });
}

exports.getClass = getClass;

function getDomainRelations(uri, model, prefixes) {
  var domainRelationQuads = model.getQuads(null, namedNode(prefixes.rdfs + "domain"), namedNode(uri), null);
  return domainRelationQuads.map(function (domainRelation) {
    return helpers_1.getElement(domainRelation.subject.id, model, prefixes);
  });
}

function getRangeRelations(uri, model, prefixes) {
  var rangeRelationQuads = model.getQuads(null, namedNode(prefixes.rdfs + "range"), namedNode(uri), null);
  return rangeRelationQuads.map(function (rangeRelation) {
    return helpers_1.getElement(rangeRelation.subject.id, model, prefixes);
  });
}

function getSupertypes(uri, model, prefixes) {
  var supertypesQuads = model.getQuads(namedNode(uri), namedNode(prefixes.rdfs + "subClassOf"), null, null);
  return supertypesQuads.map(function (superType) {
    return helpers_1.getElement(superType.object.id, model, prefixes);
  });
}

function getSubtypes(uri, model, prefixes) {
  var subtypesQuads = model.getQuads(null, namedNode(prefixes.rdfs + "subClassOf"), namedNode(uri), null);
  return subtypesQuads.map(function (subType) {
    return helpers_1.getElement(subType.subject.id, model, prefixes);
  });
}

function getStereotype(uri, model, prefixes) {
  var typesQuads = model.getQuads(namedNode(uri), namedNode(prefixes.rdf + "type"), null, null);
  var ignoreTypes = [prefixes.owl + "Class", prefixes.owl + "NamedIndividual"];
  return typesQuads.filter(function (type) {
    return !ignoreTypes.includes(type.object.id);
  }).map(function (type) {
    return helpers_1.getElement(type.object.id, model, prefixes);
  });
}